import styled from 'styled-components';
//components
import { Column, Row } from 'components/Layout/Grid';
import { Button } from 'components/Button';
import Input from 'components/Input';

export const ContainerSearch = styled(Row)`
  > div {
    align-items: flex-end;
  }
  
  .header-grid-main-row {
    gap: 32px;
    align-items: flex-end;
    width: 100%;
  }
  
  @media only screen and (max-width: 715px) {
    flex-direction: column;
    gap: 15px;
    flex: 1;

    > div + div {
      margin-left: 0;

      > div {
        width: 100%;
      }

      > button {
        width: 30%;
        margin-top: 18px;
      }
    }

    .header-grid-main-row {
      flex-direction: column;
      gap: 15px;
      align-items: stretch;
    }
  }

  @media only screen and (max-width: 370px) {
    > div {
      flex-direction: column;

      > div, > div + div {
        width: 100%;
      }

      > button {
        width: 100%;
        margin: 10px 0 0;
      }
    }
  }
`;

export const RadioButtonsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  flex-shrink: 0;
`;

export const FiltersContainer = styled.div`
  display: flex;
  gap: 16px;
  align-items: flex-end;
  flex-shrink: 0;

  .filter-buttons-container {
    display: flex;
    gap: 16px;
    align-items: center;
  }

  @media only screen and (max-width: 715px) {
    flex-direction: column;
    width: 100%;
    align-items: stretch;

    .filter-buttons-container {
      width: 100%;
      justify-content: flex-start;
    }
  }
`;

export const Divider = styled.div`
  width: 2px;
  height: 60px;
  background: #287C87;
  border-radius: 5px;
  flex-shrink: 0;

  @media only screen and (max-width: 735px) {
    display: none;
  }
`;

export const SearchContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  flex: 1 0 0;
  min-width: 0;

  .search-input-wrapper {
    position: relative;
    width: 100%;
  }

  @media only screen and (max-width: 715px) {
    width: 100%;
  }
`;

export const SearchIconWrapper = styled.div`
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
`;

export const ColumnVerticalLine = styled(Column)`
  &:before {
    content: "";
    width: 2px;
    height: 60px;

    border-radius: 5px;

    background: #287C87;
  }
  flex-direction: row;

  @media only screen and (min-width: 1024px) {
    margin-left: 2.4em;
    margin-right: 2.4em;
  }


  @media only screen and (max-width: 1023px) {
    margin-left: 1.4em;
    margin-right: 1.4em;
  }

  @media only screen and (max-width: 767px) {
    margin-left: .4em;
    margin-right: .4em;
  }

  @media only screen and (max-width: 735px) {
    display: none;
  }
`;

export const SearchInput = styled(Input).attrs<{ isOrderView?: boolean }>((props) => ({
  name: "BuscaOrigemRazaoSocialStatus",
  className: "bg-white w-100 quotesSearch"
}))<{ isOrderView?: boolean }>`
  width: 100%;
  height: 40px !important;
  min-height: 40px !important;
  border-radius: 4px;
  border: 1px solid #BEBEBE;
  padding: 8px 40px 8px 10px;
  font-family: 'Lato', sans-serif;
  font-size: 12px;
  color: #364863;

  &::placeholder {
    color: #858585;
    font-family: 'Lato', sans-serif;
    font-size: 12px;
  }

  &:focus {
    outline: none;
    border-color: #0E4C54;
  }
`;

export const CustomIcon = styled.img`
  margin-right: 8px;
  width: 16px;
  height: 16px;
`;

export const ResetButton = styled(Button)`
  &.reset-button {
    height: 40px;
    padding: 11px 16px;
    border-radius: 4px;
    border: 1px solid #0E4C54;
    background: white;
    color: #0E4C54;

    @media screen and (max-width: 715px) {
      width: 100%;
    }
  }
`;

export const SearchButton = styled(Button).attrs({
  className: 'StatusFilterButton button bg-greenDarkViveo'
})`
  width: auto;
  min-width: 70px;
  height: 40px;
  padding: 11px 16px;
  z-index: 99999;
  background: ${props => props.disabled ? "#BEBEBE" : "#0E4C54"};
  border-radius: 4px;
  border: none;

  @media screen and (max-width: 735px) {
    min-width: 70px;
  }

  @media screen and (max-width: 715px) {
    width: 100%;
  }

  &:disabled {
    opacity: 1;
  }

  > div.show {
    opacity: 1 !important;
  }
`;